export const STUBBED_INVITE_MEMBERS = [
  {
    user: {
      id: '20554437',
      firstName: 'Alex',
      lastName: 'Mousavi',
      slug: 'moose',
      location: {
        city: 'Cincinnati',
        region: 'OH',
        city_id: 5965,
        country: 313,
        latitude: 37.8045,
        longitude: -122.2714,
        regionName: 'OH',
        country_name: 'United States'
      },
      profilePhoto: {
        href: 'https://ca.slack-edge.com/T031WPQKB-UGGAMT6RZ-40be78e405e6-512',
        id: 0
      }
    },
    actions: {
      invite: {
        description: 'Invite Alex Mousavi',
        href: '#stubbedInvitationlink',
        rel: 'urn:alltrails:invite',
        title: 'Invite'
      }
    }
  },
  {
    user: {
      id: '31168399',
      firstName: 'Adam',
      lastName: 'Shoonmaker',
      slug: 'shooon',
      location: {
        city: 'Lakewood',
        city_id: 7202,
        country: 313,
        latitude: 37.787958,
        longitude: -122.403625,
        country_name: 'United States',
        region: 'CO'
      },
      profilePhoto: {
        href: 'https://ca.slack-edge.com/T031WPQKB-U019UKJ741E-18442201f516-512',
        id: 0
      }
    },
    actions: {
      invite: {
        description: 'Invite Adam Shoonmaker',
        href: '#stubbedInvitationlink',
        rel: 'urn:alltrails:invite',
        title: 'Invite'
      }
    }
  },
  {
    user: {
      id: '32034546',
      firstName: 'Danny',
      lastName: 'Clarke',
      slug: 'd-ball',
      location: {
        city: 'Los Angeles',
        city_id: 25846,
        country: 313,
        latitude: 37.952057,
        longitude: -122.074333,
        region: 'CA',
        country_name: 'United States'
      },
      profilePhoto: {
        href: 'https://ca.slack-edge.com/T031WPQKB-U01DN2QHV53-6a2c7ef5d5ef-512',
        id: 0
      }
    },
    actions: {
      invite: {
        description: 'Invite Danny Clark',
        href: '#stubbedInvitationlink',
        rel: 'urn:alltrails:invite',
        title: 'Invite'
      }
    }
  },
  {
    user: {
      id: '25809854',
      firstName: 'Travis',
      lastName: 'Crampton',
      slug: 'travity',
      location: {
        city: 'Crested Butte',
        city_id: 25846,
        country: 313,
        latitude: 37.952057,
        longitude: -122.074333,
        region: 'CO',
        country_name: 'United States'
      },
      profilePhoto: {
        href: 'https://cdn-assets.alltrails.com/uploads/photo/image/25777053/large_square_9275afb0bedba7781a4775d51d65f0d2.jpg',
        id: 0
      }
    },
    actions: {
      invite: {
        description: 'Invite Travis Crampton',
        href: '#stubbedInvitationlink',
        rel: 'urn:alltrails:invite',
        title: 'Invite'
      }
    }
  },
  {
    user: {
      id: '258098599',
      firstName: 'Conner',
      lastName: 'Drew',
      slug: 'connier',
      location: {
        city: 'San Francisco',
        city_id: 25846,
        country: 313,
        latitude: 37.952057,
        longitude: -122.074333,
        region: 'CA',
        country_name: 'United States'
      },
      profilePhoto: {
        href: 'https://ca.slack-edge.com/T031WPQKB-U01AG1VNFNY-16bd41b51d14-512',
        id: 0
      }
    },
    actions: {
      invite: {
        description: 'Invite Conner Drew',
        href: '#stubbedInvitationlink',
        rel: 'urn:alltrails:invite',
        title: 'Invite'
      }
    }
  },
  {
    user: {
      id: '258098579',
      firstName: 'Demi',
      lastName: 'Tsasis',
      slug: 'demi-t',
      location: {
        city: 'San Francisco',
        city_id: 25846,
        country: 313,
        latitude: 37.952057,
        longitude: -122.074333,
        region: 'CA',
        country_name: 'United States'
      },
      profilePhoto: {
        href: 'https://ca.slack-edge.com/T031WPQKB-U01AWJRPBP0-f1aed6646550-512',
        id: 0
      }
    },
    actions: {
      invite: {
        description: 'Invite Demi Tsasis',
        href: '#stubbedInvitationlink',
        rel: 'urn:alltrails:invite',
        title: 'Invite'
      }
    }
  },
  {
    user: {
      id: '258098399',
      firstName: 'Ron',
      lastName: 'Schneiderman',
      slug: 'ceo',
      location: {
        city: 'Oakland',
        city_id: 25846,
        country: 313,
        latitude: 37.952057,
        longitude: -122.074333,
        region: 'CA',
        country_name: 'United States'
      },
      profilePhoto: {
        href: 'https://ca.slack-edge.com/T031WPQKB-U0AB8564D-33ac6ab925a2-512',
        id: 0
      }
    },
    actions: {
      invite: {
        description: 'Invite Ron Schneiderman',
        href: '#stubbedInvitationlink',
        rel: 'urn:alltrails:invite',
        title: 'Invite'
      }
    }
  },
  {
    user: {
      id: '2584448399',
      firstName: 'Danielle',
      lastName: 'Sinclair',
      slug: 'd-sinclaire',
      location: {
        city: 'Oakland',
        city_id: 25846,
        country: 313,
        latitude: 37.952057,
        longitude: -122.074333,
        region: 'CA',
        country_name: 'United States'
      },
      profilePhoto: {
        href: 'https://ca.slack-edge.com/T031WPQKB-U1GEJ8EBZ-b4c5abe0b810-512',
        id: 0
      }
    },
    actions: {
      invite: {
        description: 'Invite Danielle Sinclair',
        href: '#stubbedInvitationlink',
        rel: 'urn:alltrails:invite',
        title: 'Invite'
      }
    }
  },
  {
    user: {
      id: '2596928399',
      firstName: 'Alex',
      lastName: 'McLean',
      slug: 'am',
      location: {
        city: 'Seattle',
        city_id: 25846,
        country: 313,
        latitude: 37.952057,
        longitude: -122.074333,
        region: 'WA',
        country_name: 'United States'
      },
      profilePhoto: {
        href: 'https://ca.slack-edge.com/T031WPQKB-U0NFH82Q1-94de5622475c-512',
        id: 0
      }
    },
    actions: {
      invite: {
        description: 'Invite Alex McLean',
        href: '#stubbedInvitationlink',
        rel: 'urn:alltrails:invite',
        title: 'Invite'
      }
    }
  }
];

export const STUBBED_FIND_FRIENDS = [
  {
    user: {
      id: '20554437',
      firstName: 'Alex',
      lastName: 'Mousavi',
      slug: 'moose',
      location: {
        city: 'Cincinnati',
        region: 'OH',
        city_id: 5965,
        country: 313,
        latitude: 37.8045,
        longitude: -122.2714,
        regionName: 'OH',
        country_name: 'United States'
      },
      profilePhoto: {
        href: 'https://ca.slack-edge.com/T031WPQKB-UGGAMT6RZ-40be78e405e6-512',
        id: 0
      }
    },
    actions: {
      follow: {
        description: 'Follow Alex Mousavi',
        href: '#stubbedInvitationlink',
        rel: 'urn:alltrails:follow',
        title: 'Follow'
      }
    }
  },
  {
    user: {
      id: '31168399',
      firstName: 'Adam',
      lastName: 'Shoonmaker',
      slug: 'shoon',
      location: {
        city: 'Lakewood',
        city_id: 7202,
        country: 313,
        latitude: 37.787958,
        longitude: -122.403625,
        country_name: 'United States',
        region: 'CO'
      },
      profilePhoto: {
        href: 'https://ca.slack-edge.com/T031WPQKB-U019UKJ741E-18442201f516-512',
        id: 0
      }
    },
    actions: {
      follow: {
        description: 'Follow Adam Shoonmaker',
        href: '#stubbedInvitationlink',
        rel: 'urn:alltrails:follow',
        title: 'Follow'
      }
    }
  },
  {
    user: {
      id: '32034546',
      firstName: 'Danny',
      lastName: 'Clarke',
      slug: 'd-ball',
      location: {
        city: 'Los Angeles',
        city_id: 25846,
        country: 313,
        latitude: 37.952057,
        longitude: -122.074333,
        region: 'CA',
        country_name: 'United States'
      },
      profilePhoto: {
        href: 'https://ca.slack-edge.com/T031WPQKB-U01DN2QHV53-6a2c7ef5d5ef-512',
        id: 0
      }
    },
    actions: {
      follow: {
        description: 'Follow Danny Clark',
        href: '#stubbedInvitationlink',
        rel: 'urn:alltrails:follow',
        title: 'Follow'
      }
    }
  },
  {
    user: {
      id: '25809854',
      firstName: 'Travis',
      lastName: 'Crampton',
      slug: 'travity',
      location: {
        city: 'Crested Butte',
        city_id: 25846,
        country: 313,
        latitude: 37.952057,
        longitude: -122.074333,
        region: 'CO',
        country_name: 'United States'
      },
      profilePhoto: {
        href: 'https://cdn-assets.alltrails.com/uploads/photo/image/25777053/large_square_9275afb0bedba7781a4775d51d65f0d2.jpg',
        id: 0
      }
    },
    actions: {
      follow: {
        description: 'Follow Travis Crampton',
        href: '#stubbedInvitationlink',
        rel: 'urn:alltrails:follow',
        title: 'Follow'
      }
    }
  },
  {
    user: {
      id: '258098599',
      firstName: 'Conner',
      lastName: 'Drew',
      slug: 'connier',
      location: {
        city: 'San Francisco',
        city_id: 25846,
        country: 313,
        latitude: 37.952057,
        longitude: -122.074333,
        region: 'CA',
        country_name: 'United States'
      },
      profilePhoto: {
        href: 'https://ca.slack-edge.com/T031WPQKB-U01AG1VNFNY-16bd41b51d14-512',
        id: 0
      }
    },
    actions: {
      follow: {
        description: 'Follow Conner Drew',
        href: '#stubbedInvitationlink',
        rel: 'urn:alltrails:follow',
        title: 'Follow'
      }
    }
  },
  {
    user: {
      id: '258098579',
      firstName: 'Demi',
      lastName: 'Tsasis',
      slug: 'demi-t',
      location: {
        city: 'San Francisco',
        city_id: 25846,
        country: 313,
        latitude: 37.952057,
        longitude: -122.074333,
        region: 'CA',
        country_name: 'United States'
      },
      profilePhoto: {
        href: 'https://ca.slack-edge.com/T031WPQKB-U01AWJRPBP0-f1aed6646550-512',
        id: 0
      }
    },
    actions: {
      follow: {
        description: 'Follow Demi Tsasis',
        href: '#stubbedInvitationlink',
        rel: 'urn:alltrails:follow',
        title: 'Follow'
      }
    }
  },
  {
    user: {
      id: '258098399',
      firstName: 'Ron',
      lastName: 'Schneiderman',
      slug: 'ceo',
      location: {
        city: 'Oakland',
        city_id: 25846,
        country: 313,
        latitude: 37.952057,
        longitude: -122.074333,
        region: 'CA',
        country_name: 'United States'
      },
      profilePhoto: {
        href: 'https://ca.slack-edge.com/T031WPQKB-U0AB8564D-33ac6ab925a2-512',
        id: 0
      }
    },
    actions: {
      follow: {
        description: 'Follow Ron Schneiderman',
        href: '#stubbedInvitationlink',
        rel: 'urn:alltrails:follow',
        title: 'Follow'
      }
    }
  },
  {
    user: {
      id: '258092878799',
      firstName: 'Danielle',
      lastName: 'Sinclair',
      slug: 'd-sinclair',
      location: {
        city: 'Oakland',
        city_id: 25846,
        country: 313,
        latitude: 37.952057,
        longitude: -122.074333,
        region: 'CA',
        country_name: 'United States'
      },
      profilePhoto: {
        href: 'https://ca.slack-edge.com/T031WPQKB-U1GEJ8EBZ-b4c5abe0b810-512',
        id: 0
      }
    },
    actions: {
      follow: {
        description: 'Follow Danielle Sinclair',
        href: '#stubbedInvitationlink',
        rel: 'urn:alltrails:follow',
        title: 'Follow'
      }
    }
  },
  {
    user: {
      id: '258094428399',
      firstName: 'Alex',
      lastName: 'McLean',
      slug: 'am',
      location: {
        city: 'Seattle',
        city_id: 25846,
        country: 313,
        latitude: 37.952057,
        longitude: -122.074333,
        region: 'WA',
        country_name: 'United States'
      },
      profilePhoto: {
        href: 'https://ca.slack-edge.com/T031WPQKB-U0NFH82Q1-94de5622475c-512',
        id: 0
      }
    },
    actions: {
      follow: {
        description: 'Follow Alex McLean',
        href: '#stubbedInvitationlink',
        rel: 'urn:alltrails:follow',
        title: 'Follow'
      }
    }
  }
];

export const stubbedFollowFriends = [
  {
    user: {
      id: '20554437',
      firstName: 'Alex',
      lastName: 'Mousavi',
      slug: 'moose',
      location: {
        city: 'Cincinnati',
        region: 'OH',
        city_id: 5965,
        country: 313,
        latitude: 37.8045,
        longitude: -122.2714,
        regionName: 'OH',
        country_name: 'United States'
      },
      profilePhoto: {
        href: 'https://ca.slack-edge.com/T031WPQKB-UGGAMT6RZ-40be78e405e6-512',
        id: 0
      }
    },
    actions: {
      accept: {
        description: 'Accept follow request from Alex Mousavi',
        href: '#stubbedInvitationlink',
        rel: 'urn:alltrails:accept',
        title: 'Accept'
      },
      dismiss: {
        description: 'Dismiss follow request from Alex Mousavi',
        href: '#stubbedInvitationlink',
        rel: 'urn:alltrails:dismiss',
        title: 'Dismiss'
      }
    }
  },
  {
    user: {
      id: '31168399',
      firstName: 'Adam',
      lastName: 'Shoonmaker',
      slug: 'shoon',
      location: {
        city: 'Lakewood',
        city_id: 7202,
        country: 313,
        latitude: 37.787958,
        longitude: -122.403625,
        country_name: 'United States',
        region: 'CO'
      },
      profilePhoto: {
        href: 'https://ca.slack-edge.com/T031WPQKB-U019UKJ741E-18442201f516-512',
        id: 0
      }
    },
    actions: {
      accept: {
        description: 'Accept follow request from Adam Shoonmaker',
        href: '#stubbedInvitationlink',
        rel: 'urn:alltrails:accept',
        title: 'Accept'
      },
      dismiss: {
        description: 'Dismiss follow request from Adam Shoonmaker',
        href: '#stubbedInvitationlink',
        rel: 'urn:alltrails:dismiss',
        title: 'Dismiss'
      }
    }
  }
];
